import {
  DeviceTypes,
  useDeviceContext,
} from '@infield/providers/device-provider';

export const useIsDesktop = (): boolean => {
  const { device } = useDeviceContext();
  return device === DeviceTypes.desktop;
};
